/* eslint-disable indent */
import Vue from 'vue';
import i18n from 'common-module/src/lang';

let VXETablePromise = null;

const load = () => {
  if (!VXETablePromise) {
  // eslint-disable-next-line no-async-promise-executor
    VXETablePromise = new Promise(async (resolve, reject) => {
      try {
        const XEUtils = await window.importByCDN('xe-utils');
        const VXETable = await window.importByCDN('vxe-table');
        const allImports = [];
        allImports.push(import('vxe-table/lib/locale/lang/en-US'));
        allImports.push(import('vxe-table/lib/locale/lang/zh-CN'));
                                                    
                                                           
                 
        const results = await Promise.all(allImports);

        Vue.use(VXETable, {
          // 对组件内置的提示语进行国际化翻译
          i18n: (key, args) => {
            let language = results[1].default || results[1];
            if (i18n.locale === 'en') {
              language = results[0].default || results[0];
            }
            return XEUtils.toFormatString(XEUtils.get(language, key), args);
          },
          table: {
            autoResize: true
          }
        });
        resolve(VXETable);
      } catch (e) {
        reject(e);
      }
    });
  }
  return VXETablePromise;
};

Vue.component('VxeTable', async (resolve, reject) => {
  try {
    const VXETable = await load();
    resolve(VXETable.Table);
  } catch (e) {
    reject(e);
  }
});

Vue.component('VxeTableColumn', async (resolve, reject) => {
  try {
    const VXETable = await load();
    resolve(VXETable.Column);
  } catch (e) {
    reject(e);
  }
});

Vue.component('VxeColumn', async (resolve, reject) => {
  try {
    const VXETable = await load();
    resolve(VXETable.Column);
  } catch (e) {
    reject(e);
  }
});
Vue.component('VxeGrid', async (resolve, reject) => {
  try {
    const VXETable = await load();
    resolve(VXETable.Grid);
  } catch (e) {
    reject(e);
  }
});
